<template>
  <div class="flex items-center"
    :title="span?'Kendisiyle iletişim kurulmasını istemiyor':customer"
  >
    <vs-avatar
      :src="params.data.avatar ? params.data.avatar : this.$defaultPicture"
      class="flex-shrink-0 mr-2"
      size="30px"
      @click="$router.push(url)"
    />
    <router-link
      :to="url"
      @click.stop.prevent
      class="text-inherit hover:text-primary"
    >
      <span v-html="customer"></span>
      <span v-if="span" class="danger"><b>&nbsp;(Kendisiyle iletişim kurulmasını istemiyor)</b></span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "CellRendererLink",
  data() {
    return {
      customer: "",
      span: "",
    };
  },
  computed: {
    url() {
      return "/contactsView/" + this.params.data.customerId;
    },
  },
  beforeMount() {
    this.customer = this.params.value;
    let span = this.customer.indexOf("</span>");
    if (span > 0) {
      this.span = this.customer.substr(0, span + 7);
      this.customer = this.customer.substr(span + 7).trim();
    }
  },
};
</script>
